<template>
  <div>
    <div class="sa-timer">Connected {{payloadUserDetails.pname}} <div>{{$parent.timerUpdate}}</div></div>
    <ul class="sa-phone-list">
      <li @click="muteLocalParticipant" v-if="$parent.localControls.muted">
        <i class="icon-micon"></i>
      </li>
      <li @click="muteLocalParticipant" v-if="!$parent.localControls.muted">
        <i class="icon-mute"></i>
      </li>
      <li
        class="sa-dark-gray-bg"
        @click="showLocalParticipant"
        v-if="$parent.localControls.video"
      >
        <i class="icon-video2 sa-white-text"></i>
      </li>
      <li
        class="sa-dark-gray-bg"
        @click="showLocalParticipant"
        v-if="!$parent.localControls.video"
      >
        <i class="icon-video-off sa-white-text"></i>
      </li>
      <li class="sa-red-bg" @click="disconnectCall">
        <i class="icon-call2 sa-white-text"></i>
      </li>
      <li v-if="!videoMinimised" @click="minMax">
        <i class="icon-chat3"></i>
        <span v-if="$parent.msgTextflag" class="sa-badge sa-badge-danger">New</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Controls",
  methods: {
    muteLocalParticipant() {
      this.$parent.$emit("onMute");
    },
    showLocalParticipant() {
      this.$parent.$emit("onVideo");
    },
    disconnectCall() {
      this.$parent.$emit("onDisconnect");
      if(this.videoMinimised){
        this.$store.dispatch("SET_VIDEO_LAYOUT");
      }
    },
    minMax() {
      this.$parent.$emit("onChat");
      this.$store.dispatch("SET_VIDEO_LAYOUT");
    },
  },
  computed: {
    videoMinimised() {
      return this.$store.getters.videoMinimised
    },
    payloadUserDetails(){ 
            return JSON.parse(this.$localStorage.get("appDetails"))
        }
  }
};
</script>